import ErrorBoundary from "../ErrorBoundary";

export default function RosterPlannerErrorBoundary({ children }) {
  return (
    <ErrorBoundary
      compact
      title="Roster planner couldn't load"
      message="Something went wrong while loading the roster. Refresh the page or pick another roster plan. Your data is safe."
    >
      {children}
    </ErrorBoundary>
  );
}
